module.exports = __webpack_public_path__ + "img/headSculpture.18984df7.png";